/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Step_Length_RangeInputs */

const en_exp_step_length_range = /** @type {(inputs: Exp_Step_Length_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most runners land between 0.9 and 1.4 m, longer as they speed up. Long steps at a low cadence can mean overstriding.`)
};

const de_exp_step_length_range = /** @type {(inputs: Exp_Step_Length_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meisten liegen zwischen 0,9 und 1,4 m — je schneller, desto länger. Lange Schritte bei niedriger Kadenz heißen oft: du setzt zu weit vor dem Körper auf.`)
};

/**
* | output |
* | --- |
* | "Most runners land between 0.9 and 1.4 m, longer as they speed up. Long steps at a low cadence can mean overstriding." |
*
* @param {Exp_Step_Length_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_step_length_range = /** @type {((inputs?: Exp_Step_Length_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Step_Length_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_step_length_range(inputs)
	return de_exp_step_length_range(inputs)
});